export {default} from './OrdersReportDataRenderer.connect';
